import axios from 'axios';

const baseURL = import.meta.env.VITE_API_BASE_URL || '';

// 默认 180s —— 大部分 LLM 调用(简历解析 / 简历筛选 / 需求分析)
// 在 thinking 模型(MiniMax-M2.7)上要 60-120s,留一倍 buffer。
// CRUD 路径实际只需毫秒级,这个上限不影响体感。
export const api = axios.create({
  baseURL,
  timeout: 180_000,
});

// 把 backend 返回的相对资源路径(如 /uploads/recordings/xxx.mp3)
// 转成绝对 URL,避开 vite dev 的 SPA fallback。
// 生产环境 baseURL 一般为空(走 nginx 代理同 origin),此时 STATIC_BASE_URL 也用空,
// absoluteUrl 直接返回相对路径,让浏览器用当前 host(zhaopinagent.com 或 IP)。
// 开发环境(vite dev :5173)会显式设 VITE_API_BASE_URL 指向 localhost:8000。
const STATIC_BASE_URL =
  import.meta.env.VITE_STATIC_BASE_URL ||
  baseURL ||
  '';

export function absoluteUrl(path: string | null | undefined): string {
  if (!path) return '';
  if (/^https?:\/\//.test(path)) return path; // 已经是绝对
  // 没配静态 base URL → 直接返回相对路径(浏览器自动用当前 origin)
  if (!STATIC_BASE_URL) return path.startsWith('/') ? path : '/' + path;
  return `${STATIC_BASE_URL.replace(/\/$/, '')}${path.startsWith('/') ? path : '/' + path}`;
}

// localStorage token key
const TOKEN_KEY = 'auth_token';
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t: string | null) => {
  if (t) localStorage.setItem(TOKEN_KEY, t);
  else localStorage.removeItem(TOKEN_KEY);
};

// Request: 自动加 Bearer token
api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) {
    config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});

// Response: 401 自动跳登录
api.interceptors.response.use(
  (resp) => resp,
  (err) => {
    const code = err.response?.status;
    const msg = err.response?.data?.detail || err.message;
    console.error('[API]', err.config?.url, code, msg);

    // 401 → 清 token 跳登录(候选人 by-token 接口除外)
    if (code === 401 && !err.config?.url?.includes('/by-token/')) {
      setToken(null);
      // 避免循环跳转:登录/注册页本身 401 不跳
      const path = window.location.pathname;
      if (!path.startsWith('/login') && !path.startsWith('/register') && !path.startsWith('/interview/')) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(new Error(msg));
  }
);
